import React, {useRef, useState, useEffect} from "react";
import {observer, inject} from "mobx-react";

import {Formik, Form, useField} from 'formik';
import * as Yup from 'yup';
import {TextInput, CheckboxInput, TextLabel} from "@components/Form/FormFields";


@inject("store")
@observer
export default class CustomerAccount extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            customerAccountAdmin: null,
            customerAccount: null
        };
    }

    componentDidMount() {
        const customerId = this.props.store.navigation.getCustomerId();
        const isAdmin = this.props.store.account.Roles.indexOf("icom-admin") > -1;

        this.props.store.beriksson.customerAccount().then(res => {
            this.setState({customerAccount: res})
        })
    }

    render() {
        if (!this.props.store.navigation.getCustomerId()) {
            return <div>Error: No customer choosen</div>;
        }


        return (
            <div
            >

                <div className="row">
                    <div className="col-12">
                        {this.state.customerAccount && <AccountForm
                            customerAccount={this.state.customerAccount}
                            berikssonStore={this.props.store.beriksson}
                            navigation={this.props.store.navigation}
                        />}
                    </div>
                </div>

       
            </div>);

    }
}


const AccountForm = ({...props}) => {

    return (
        <Formik
            validateOnMount={true}
            enableReinitialize={true}
            initialValues={{
                cultureCode: props.cultureCode,
                nodeId: props.nodeId,
                //customerNumber: props.customerAccount.CustomerNumber,
                //customerName: props.customerAccount.CustomerName,
                //customerOrganisationNumber: props.customerAccount.CustomerOrganisationNumber,
                customerInvoiceEmail: props.customerAccount.CustomerInvoiceEmail,
                customerInvoiceByEmail: props.customerAccount.CustomerInvoiceByEmail,
            }}
            validationSchema={Yup.object({

                customerInvoiceEmail: Yup.string()
                    .email('Ogiltig epostadress')
                    .required('Måste anges'),
            })}
            //onSubmit={onSubmitWithReCAPTCHA}
            onSubmit={(values, {setSubmitting}) => {
                
                props.berikssonStore.customerAccountUpdate(values).then(res => {
                    console.log("berikssonStore.customerUpdate() => ", res)
                    props.navigation.toast("Uppgifterna sparades");
                    setSubmitting(false);
                })


            }}

        >
            {({values, setSubmitting, isSubmitting, handleBlur, setFieldValue, isValid}) => {
                //  noValidate
                return <Form>
                    <h4 className="text-normal pt-4">Företagsuppgifter</h4>
                    <hr className="mb-3"/>
                    <div className={"row"}>
                        <div className={"col-sm-4"}>

                            <TextLabel
                                label="Kundnummer"
                                name="customerNumber"
                                value={props.customerAccount.CustomerNumber}

                            /></div>
                        <div className={"col-sm-4"}>
                            <TextLabel
                                label="Företagsnamn"
                                name="customerName"
                                value={props.customerAccount.CustomerName}
                            /></div>
                        <div className={"col-sm-4 "}>
                            <TextLabel
                                label="Organisationsnummer"
                                name="customerOrganisationNumber"
                                type="text"
                                value={props.customerAccount.CustomerOrganisationNumber}
                            />
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-sm-4 "}>
                            <TextInput
                                label="Företagets E-postadress (för faktura)"
                                name="customerInvoiceEmail"
                                type="text"
                            /></div>
                        <div className={"col-sm-4 "}>
                            <CheckboxInput
                                id="customerEmailByInvoice"
                                label="Faktura per epost"
                                name="customerInvoiceByEmail"
                            >
                                Kryssa ur rutan om du önskar fakturan per brevpost.
                            </CheckboxInput>
                        </div>
                    </div>

                    <button className="btn btn-success"
                            type="submit"
                            disabled={isSubmitting || !isValid}>Spara
                    </button>

                </Form>
            }
            }
        </Formik>
    );
};

